import useStyles from './styles';
import DropZone from '../DropZone';
import FilePreview from '../FilePreview';
import useUploadArea from '@/hooks/useUploadArea';
import type { UploadAreaProps } from '@/types/upload';

const UploadArea = ({
  label,
  accept = 'image/*',
  value,
  isLoading,
  isVideo,
  hasError = false,
  hasUploadError = false,
  onUpload,
  onRemove,
  onSelectFromDrive,
  onSelectFromCanvas,
  onSelectFromNativePicker,
  hasCanvasImages,
  compact = false,
  title,
  allowedExtensions,
}: UploadAreaProps) => {
  const classes = useStyles();
  const upload = useUploadArea({
    accept,
    value,
    hasUploadError,
    onUpload,
    onRemove,
  });

  return (
    <div className={classes.container}>
      {label && <span className={classes.label}>{label}</span>}
      <input
        ref={upload.inputRef}
        type="file"
        accept={accept}
        onChange={upload.handleChange}
        className={classes.hidden}
      />
      {upload.previewUrl ? (
        <FilePreview
          previewUrl={upload.previewUrl}
          isVideo={isVideo}
          isLoading={isLoading}
          isRemoving={upload.isRemoving}
          compact={compact}
          onRemove={onRemove ? upload.handleRemove : undefined}
        />
      ) : (
        <DropZone
          accept={accept}
          title={title}
          allowedExtensions={allowedExtensions}
          hasError={hasError}
          hasUploadError={hasUploadError}
          showInvalidState={upload.showInvalidState}
          isDragging={upload.isDragging}
          onSelectFromDrive={onSelectFromDrive}
          onSelectFromCanvas={onSelectFromCanvas}
          onSelectFromNativePicker={onSelectFromNativePicker}
          hasCanvasImages={hasCanvasImages}
          onOpenFilePicker={upload.openFilePicker}
          onClearInvalidFeedback={upload.clearInvalidFeedback}
          onDrop={upload.handleDrop}
          onDragOver={upload.handleDragOver}
          onDragEnter={upload.handleDragEnter}
          onDragLeave={upload.handleDragLeave}
        />
      )}
    </div>
  );
};

export default UploadArea;
